import React from 'react'
import Badge from '@/admin/shared/components/Badge/Badge'
import type { User } from '../types'

interface UserStatusBadgeProps {
  user: Pick<User, 'status' | 'remove_date'>
}

export default function UserStatusBadge({ user }: UserStatusBadgeProps) {
  if (user.remove_date) {
    const removeAt = new Date(user.remove_date)
    removeAt.setHours(removeAt.getHours() + 24)
    return (
      <Badge variant="danger" dot>
        Removal {removeAt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
      </Badge>
    )
  }

  return (
    <Badge variant={user.status === 'active' ? 'success' : 'danger'} dot>
      {user.status === 'active' ? 'Active' : 'Disabled'}
    </Badge>
  )
}

